import React from "react";
import "./App.css";

const { NotificationContainer } = require("react-notifications");

export const AppLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="modquiz-app">
    <NotificationContainer />
    <header className="modquiz-masthead">
      <div>
        <strong>MODQUIZ</strong>
      </div>
      <span className="modquiz-masthead__mark" aria-hidden="true">MQ / 01</span>
    </header>
    <div className="modquiz-shell">{children}</div>
  </div>
);

export { modquizRoutes, modquizPaths, Landing } from "./routes";
